module.exports = __webpack_public_path__ + "img/dish3.e13073d4.png";